// Resolve versions only through an unambiguous English relationship, never a name.
export function medicineLanguageDestination({ base, medicines, fromLanguage, toLanguage, entryId, sourceEntryId, adding, search = "" }) {
  const query = new URLSearchParams(search);
  for (const key of ["page", "selected", "source", "coveragePage", "coverageSearch"]) query.delete(key);
  const suffix = () => query.toString() ? `?${query}` : "";
  if (!entryId && !sourceEntryId) return { to: `${base}/${toLanguage}${adding ? "/new" : ""}${suffix()}` };
  const english = medicines.find(group => group.lang === "en")?.data || [];
  const current = medicines.find(group => group.lang === fromLanguage)?.data.find(row => String(row._id) === entryId);
  const source = sourceEntryId ? english.find(row => String(row._id) === sourceEntryId)
    : fromLanguage === "en" ? current : english.find(row => row.fixedMedicineId === current?.medicineDetectorId);
  if (!source || english.filter(row => row.fixedMedicineId === source.fixedMedicineId).length !== 1) {
    return { error: "This medicine has no unique English source. Its language relationship must be resolved before switching versions." };
  }
  const matches = toLanguage === "en" ? [source] : (medicines.find(group => group.lang === toLanguage)?.data || [])
    .filter(row => row.medicineDetectorId === source.fixedMedicineId);
  if (matches.length > 1) return { error: "Multiple versions exist in this language. Resolve the duplicate relationship before switching." };
  if (matches.length === 1) return { to: `${base}/${toLanguage}/${matches[0]._id}/edit${suffix()}` };
  query.set("source", String(source._id));
  return { to: `${base}/${toLanguage}/new${suffix()}` };
}
